// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, onAuthStateChanged, signInAnonymously } from 'firebase/auth';
import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyByXy2_k6Xu55OEI8Ir4gSXH2WFYV6Ml_w",
  authDomain: "cost-to-construction.firebaseapp.com",
  projectId: "cost-to-construction",
  storageBucket: "cost-to-construction.firebasestorage.app",
  messagingSenderId: "562394171179",
  appId: "1:562394171179:web:04c11600fcbfb7d3ff276e",
  measurementId: "G-BZ2KBHPLJJ" // From your screenshot
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Start an anonymous session ASAP and keep it fresh
export async function ensureSignedIn() {
  return new Promise((resolve, reject) => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      try {
        if (!user) {
          console.log('🔐 Signing in anonymously...');
          await signInAnonymously(auth);
        } else {
          console.log('✅ Already authenticated:', user.isAnonymous ? 'Anonymous' : user.email);
          
          // Set user ID for analytics
          if (analytics) {
            setUserId(analytics, user.uid);
            setUserProperties(analytics, {
              user_type: user.isAnonymous ? 'anonymous' : 'registered'
            });
          }
        }
        resolve();
      } catch (e) {
        console.error('❌ Authentication failed:', e);
        reject(e);
      } finally {
        unsub();
      }
    });
  });
}

// Analytics helper functions
export const trackEvent = (eventName, parameters = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
    console.log(`📊 Analytics: ${eventName}`, parameters);
  }
};

export const trackPageView = (pagePath, pageTitle) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

export const trackProjectEstimate = (projectType, city, state, costRange) => {
  if (analytics) {
    logEvent(analytics, 'estimate_requested', {
      project_type: projectType,
      city: city,
      state: state,
      cost_range: costRange,
      value: costRange ? parseInt(costRange.split('-')[0].replace(/\D/g, '')) : 0
    });
  }
};

export const trackQuestionAnswered = (questionNumber, answer, projectType) => {
  if (analytics) {
    logEvent(analytics, 'question_answered', {
      question_number: questionNumber,
      answer: answer,
      project_type: projectType
    });
  }
};

export const trackFinalEstimate = (projectType, totalCost, breakdown) => {
  if (analytics) {
    logEvent(analytics, 'estimate_completed', {
      project_type: projectType,
      total_cost: totalCost,
      currency: 'USD',
      value: totalCost
    });
  }
};

export default app;
